import React from 'react';
import { MathboxLine } from '../Lines';

const PackageSavings = ({ pricing }) => {
  return (
    <div className="math-box__package-savings">
      <MathboxLine
        labelKey="total.before.opd"
        price={pricing.totalMsrpBeforeOpd}
        className="before-package-discount"
      />
      <MathboxLine
        labelKey="package.discount"
        price={pricing.opdTotal}
        className="package-savings"
      />
    </div>
  );
};

export default PackageSavings;
